const TOKEN = 'screening-api-token';
const MOBILE_NUMBER = 'screening-api-phone';
const CALL_OPT = 'screening-app-call';
const USER_ID = 'screening-app-userId';

const TEXT_RETRY = 'screening-app-text-retry';
const SMS_OPT_IN = 'screening-app-sms-opt-in';


export const getToken = () => window.sessionStorage.getItem(TOKEN);

export const setToken = token => window.sessionStorage.setItem(TOKEN, token);

export const revokeToken = () => window.sessionStorage.removeItem(TOKEN);

export const getUserId = () => window.sessionStorage.getItem(USER_ID);


export const getSmsOptInStatus = () =>
  Boolean(window.localStorage.getItem(SMS_OPT_IN));

export const setSmsOptInStatus = value =>
  window.localStorage.setItem(SMS_OPT_IN, value);

export const getVoiceCallFailure = () =>
  parseInt(window.sessionStorage.getItem(TEXT_RETRY) || 0);


export const setUserId = userId =>
  window.sessionStorage.setItem(USER_ID, userId);

export const getMobileNumber = () =>
  window.sessionStorage.getItem(MOBILE_NUMBER);

export const setMobileNumber = phone =>
  window.sessionStorage.setItem(MOBILE_NUMBER, phone);

export const getCallChoice = () => {
  const storage = window.sessionStorage.getItem(CALL_OPT);
  return storage === 'true';
};


export const incrementVoiceCallFailure = () => {
  const current = getVoiceCallFailure() || 0;
  window.sessionStorage.setItem(TEXT_RETRY, current + 1);
};
export const resetVoiceCallFailure = () => {
  window.sessionStorage.setItem(TEXT_RETRY, 0);
};


export const setCallChoice = opt =>
  window.sessionStorage.setItem(CALL_OPT, opt);
